import { PartialSummary, PolicyRuleAlerts } from '@reveni-io/reveni-ui'

import useCancellationsPortal from '@/hooks/useCancellationsPortal/useCancellationsPortal'
import useCustomLogisticsLabel from '@/hooks/useCustomLogisticsLabel/useCustomLogisticsLabel'
import useSummary from '@/hooks/useSummary/useSummary'

import * as Styles from './styles'

const Summary = ({ showReminder = true, showDistinctCurrencyReminder = false, isCollapsable = true }) => {
  const { summary, summaryCollapsed, storeCurrency, feeMessages } = useSummary()
  const { isCancellationsPortal } = useCancellationsPortal()
  const customLogisticsLabel = useCustomLogisticsLabel()

  return (
    <Styles.SummaryContainer>
      <PartialSummary
        total={summary?.remaining_amount}
        productsToReturn={summary?.productsToReturn}
        newRequestedProducts={summary?.newRequestedProducts}
        fees={summary?.fees}
        bonuses={summary?.bonuses}
        isCollapsable={isCollapsable}
        collapsedByDefault={summaryCollapsed}
        reminder={showReminder}
        currency={summary?.currency}
        storeCurrency={storeCurrency}
        showDistinctCurrencyReminder={showDistinctCurrencyReminder}
        isCancellationsPortal={isCancellationsPortal}
        customLogisticsLabel={customLogisticsLabel}
      />
      <Styles.FeeMessagesContainer>
        <PolicyRuleAlerts displayMessages={feeMessages} />
      </Styles.FeeMessagesContainer>
    </Styles.SummaryContainer>
  )
}

export default Summary
